import { useEventListener } from '@bonusly/events';
import { useIdentity } from '@bonusly/who-am-i';

import { GiveBoxEvent } from '../events';

export const useEventListeners = () => {
	const { refetchProfile } = useIdentity();

	useEventListener(GiveBoxEvent.Created, () => {
		refetchProfile();
	});

	useEventListener(GiveBoxEvent.Deleted, () => {
		refetchProfile();
	});
};
